import { getRequest } from '@fo-apis/axios';

const getPolicyHistoryList = (additionalTypeCd) =>
  getRequest({
    url: `/api/v1/system/policy/history-list`,
    params: {
      additionalTypeCd,
    },
  });

const getPolicyContent = ({ additionalTypeCd, applyStartDateTime }) => {
  return getRequest({
    url: '/api/v1/system/policy',
    params: {
      additionalTypeCd,
      applyStartDateTime,
    },
  });
};

const getPolicyAvailable = ( additionalTypeCd ) => {
  return getRequest({
    url: '/api/v1/system/policy/avail-policy',
    params: {
      additionalTypeCd,
    },
  });
};

const policyApi = {
  getPolicyHistoryList,
  getPolicyContent,
  getPolicyAvailable,
};

export default policyApi;
